/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const awsAccountCostGet = /* GraphQL */ `
  query AwsAccountCostGet($billingPeriod: String!) {
    awsAccountCostGet(billingPeriod: $billingPeriod) {
      billingPeriod
      costAmount
      currency
    }
  }
`;
export const costRateGetCurrent = /* GraphQL */ `
  query CostRateGetCurrent {
    costRateGetCurrent {
      characterCostRate
      effectiveTimestamp
      id
      updatedBy
    }
  }
`;
export const helpListHelps = /* GraphQL */ `
  query HelpListHelps($limit: Int, $nextToken: String) {
    helpListHelps(limit: $limit, nextToken: $nextToken) {
      items {
        description
        id
        link
        order
        title
      }
      nextToken
    }
  }
`;
export const reportScheduleGetConfig = /* GraphQL */ `
  query ReportScheduleGetConfig {
    reportScheduleGetConfig {
      format
      id
      recipients
      schedule
      updatedAt
      updatedBy
    }
  }
`;
export const sharedGetPreferences = /* GraphQL */ `
  query SharedGetPreferences {
    sharedGetPreferences {
      visualDensity
      visualMode
    }
  }
`;
export const translationListJobs = /* GraphQL */ `
  query TranslationListJobs($limit: Int, $nextToken: String) {
    translationListJobs(limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        jobName
        jobOwner
        jobStatus
        languageSource
        languageTargets
        translateKey
      }
      nextToken
    }
  }
`;
export const usageListAllRecords = /* GraphQL */ `
  query UsageListAllRecords($billingPeriod: String!, $jobType: String) {
    usageListAllRecords(billingPeriod: $billingPeriod, jobType: $jobType) {
      items {
        archived
        billingPeriod
        contentType
        costRateApplied
        estimatedCost
        id
        incomplete
        jobId
        jobType
        metricType
        metricValue
        sourceLanguage
        targetLanguageCount
        timestamp
        userId
        userName
      }
      nextToken
    }
  }
`;
export const usageListRecords = /* GraphQL */ `
  query UsageListRecords($billingPeriod: String!, $userId: String) {
    usageListRecords(billingPeriod: $billingPeriod, userId: $userId) {
      items {
        archived
        billingPeriod
        contentType
        costRateApplied
        estimatedCost
        id
        incomplete
        jobId
        jobType
        metricType
        metricValue
        sourceLanguage
        targetLanguageCount
        timestamp
        userId
        userName
      }
      nextToken
    }
  }
`;
